import { createSelector } from 'reselect';
import { getDeployment } from './config';
import { GlobalState } from '../rootReducer';
import { postResetPassword } from '@/redux/api/auth';

/* Action Types */
const PASSWORD_RESET_FAIL = 'la/ui/passwordReset/FAIL';
export const PASSWORD_RESET_REQUEST = 'la/ui/passwordReset/REQUEST';
export const PASSWORD_RESET_SUCCESS = 'la/ui/passwordReset/SUCCESS';

// reducer
const DEFAULT_STATE = {
    error: false,
    errorMessage: null,
    submitted: false,
    success: false,
};

export type State = typeof DEFAULT_STATE;

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case PASSWORD_RESET_REQUEST:
            return {
                ...state,
                error: false,
                errorMessage: null,
                submitted: true,
                success: false,
            };
        case PASSWORD_RESET_SUCCESS:
            return {
                ...state,
                submitted: false,
                success: true,
            };
        case PASSWORD_RESET_FAIL:
            return {
                ...state,
                error: true,
                errorMessage: action.payload,
                submitted: false,
                success: false,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.passwordReset;

export const getUiPasswordReset = createSelector(stateSelector, (state) => state);

/* ACTION CREATORS */
type SubmitPasswordResetParams = {
    bidderId: number;
    hash: string;
    newPassword: string;
};
export const submitPasswordReset = ({ bidderId, hash, newPassword }: SubmitPasswordResetParams) => async (
    dispatch: Function,
    getState: Function
) => {
    try {
        const state = getState();
        const deployment = getDeployment(state);
        dispatch({
            payload: bidderId,
            type: PASSWORD_RESET_REQUEST,
        });
        const response = await await postResetPassword({ bidderId, deployment, hash, newPassword });
        dispatch({
            meta: { actionTime: Date.now() },
            payload: response.data,
            type: PASSWORD_RESET_SUCCESS,
        });
    } catch (error) {
        dispatch({
            error: true,
            meta: { bidderId },
            payload: error,
            type: PASSWORD_RESET_FAIL,
        });
    }
};
